module.exports = __webpack_public_path__ + "static/media/human.344fe5e1.svg";